import React, { useState } from 'react';
import { HvTypography, HvListContainer, HvListItem, HvDialog, HvDialogTitle, HvDialogContent, HvButton } from '@hitachivantara/uikit-react-core';
import { HvStepNavigation } from '@hitachivantara/uikit-react-lab';
import { makeStyles } from "@mui/styles";
import { Box } from '@mui/material';
import { withRouter } from 'react-router';

const ISVRequest = ({ history }) => {
    const [open, setOpen] = useState(true);
    const [showInternal, setShowInternal] = useState(true);
    const [showPartner, setShowPartner] = useState(false);
   
    const title = "Co-Creation Request";
    
    const internalLink = 'https://hdscorp.lightning.force.com/lightning/page/home'
    const partnerLink = 'https://partnerportal.hitachivantara.com/s/'

    const classes = makeStyles((theme) => ({
        separator: {
          backgroundColor: [theme.palette.acce2, "!important"],
        },
        title: {
          color: theme.palette.acce2,
        },
        ghostDisabled: {},
        ghost: {
          backgroundColor: [theme.palette.acce2, "!important"],
          "&$ghostDisabled": {
            backgroundColor: [theme.palette.acce2, "!important"],
          },
          "&$ghostDisabled&:hover": {
            backgroundColor: [theme.palette.acce2, "!important"],
          },
        },
      }))();

    const steps = [
        {
            title: "HVInternal",
            onClick: () => {
                setShowPartner(false);
                setShowInternal(true);
               
            },

            state : showInternal ? "Completed" : "Enabled"
        },

        {
            title: "Partner",
            onClick: () => {
                setShowPartner(true);
                setShowInternal(false);

            },
            state : showPartner ? "Completed" : "Enabled"
        },
    ]
    return (
        <>
            <HvDialog disableBackdropClick
                open={open}
                fullscreen
                onClose={() => {
                    setOpen(false);
                    history.push("/labs");
                }}
                id="test"
                firstFocusable="test-close">
                <HvDialogTitle variant="info">{title}</HvDialogTitle>
                <HvStepNavigation 
                type='Default'
                steps={steps.map((s) => ({
                    ...s,
                    separatorClassName: classes.separator,
                    titleClassName: classes.title,
                }))}

                    id="Width"
                    width={{
                        xs: 200,
                        sm: 400,
                        md: 600,
                        lg: 800,
                        xl: 1000,
                    }}
                    style={{
                        display : "flex",
                        flexDirection : "column",
                        width:"100%"
                    }} />
                <HvDialogContent indentContent>
                    {
                        showInternal ? <div name="HV Internal">
                             <HvTypography variant="mTitle" component="h2">
                                Internal
                            </HvTypography>
                            {/* <Box display='flex' alignSelf='center' padding='10px' gap={3}>
                                <HvTypography variant="mTitle" component="h2">
                                    •Visit Salesforce to submit a Co-Creation request:
                                </HvTypography>
                                <HvTypography variant='link' style={{ cursor: 'pointer', alignSelf: 'center' }} onClick={() => { window.open(internalLink) }}>https://hdscorp.lightning.force.com/lightning/page/home</HvTypography>
                            </Box> */}
                            <HvTypography variant="normalText" component="p">
                                <HvListContainer>
                                    <HvListItem >•	For PreSales support, start from within an Opportunity or Quote and click the "Request GPSE Service" button.</HvListItem>
                                    <HvListItem >•	For post sales support, start from a Customer, Partner, or Prospect Account and click the "Request GPSE Service" button.</HvListItem>
                                    <HvListItem> •	You may need to click on the drop-down arrow first to see the option. </HvListItem>
                                    <img src='./assets/images/Salesforce-GPSE1.png'></img>
                                    <img src='./assets/images/Salesforce-GPSE2.png'></img>
                                    <HvListItem> •	Select “Technology Partner Co-Creation Lab” and complete the required fields. </HvListItem>
                                    <HvListItem> •	We will contact you within 48 hours with next steps. </HvListItem>
                                    <Box display='flex' alignSelf='center' gap={1}>
                                        <HvListItem style={{ alignSelf: 'center' }}> •	For questions or assistance contact: </HvListItem>
                                        <HvTypography style={{ cursor: 'pointer', alignSelf: 'auto', paddingTop: '5px' }} variant='link'>gpse.isv@hitachivantara.com</HvTypography>
                                    </Box>
                                    <HvListItem>
                                        <HvButton onClick={() => { window.open(internalLink) }}>Go To SalesForce Page</HvButton>
                                    </HvListItem>
                                </HvListContainer>
                            </HvTypography>

                        </div> : <></>
                    }

                    {
                        showPartner ? <div name="Partner">
                            <HvTypography variant="mTitle" component="h2">
                                Partner
                            </HvTypography>
                            <HvTypography variant="normalText" component="p">
                                <HvListContainer>
                                    <HvListItem >•	Hover over the Sales dropdown </HvListItem>
                                    <HvListItem> •	For PreSales support, start from within an Opportunity or Quote and click the "Request GPSE Service" button.</HvListItem>
                                    <img src='./assets/images/Salesforce-Partner1.jpg' width='90%' height='50%'></img><br />
                                    <img src='./assets/images/Salesforce-Partner2.jpg' width='90%' height='50%'></img>
                                    <HvListItem> •	For post sales support, start from a Customer, Partner, or Prospect Account and click the "Request GPSE Service" button. </HvListItem>
                                    <HvListItem> •	You may need to click on the drop-down arrow first to see the option.</HvListItem>
                                    <HvListItem> •	Select “Technology Partner Co-Creation Lab” and complete the required fields.</HvListItem>
                                    <HvListItem> •	We will contact you within 48 hours with next steps. </HvListItem>
                                    <Box display='flex' alignSelf='center' gap={1}>
                                        <HvListItem style={{ alignSelf: 'center' }}> •	For questions or assistance contact: </HvListItem>
                                        <HvTypography style={{ cursor: 'pointer', alignSelf: 'auto', paddingTop: '5px' }} variant='link'>gpse.isv@hitachivantara.com</HvTypography>
                                    </Box>
                                    <HvListItem>
                                        <HvButton onClick={() => { window.open(partnerLink) }}>Go To SalesForce Page</HvButton>
                                    </HvListItem>
                                </HvListContainer>
                            </HvTypography>
                        </div>

                            : <></>
                    }


                </HvDialogContent>
            </HvDialog>

        </>
    );
}





export default withRouter(ISVRequest);